var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SchemaTablePage", {
    ref: "tablePageRef",
    attrs: {
      "layout-mode": "page",
      "search-schema": _vm.searchSchema,
      columns: _vm.tableColumns,
      "default-query": _vm.defaultQuery,
      request: _vm.request,
      "build-params": _vm.buildParams,
      "parse-result": _vm.parseResult,
    },
    scopedSlots: _vm._u([
      {
        key: "colMemberAccount",
        fn: function ({ row }) {
          return [
            _c("MemberAccountCell", {
              attrs: {
                row: row,
                username: row.target_name,
                uid: row.target_id,
                "vip-level": row.vip_level,
                "default-detail-tab-type": "memberLogs",
              },
            }),
          ]
        },
      },
      {
        key: "colBefore",
        fn: function ({ row }) {
          return [
            _c(
              "el-popover",
              { attrs: { placement: "top", width: "400", trigger: "hover" } },
              [
                _c("div", { staticStyle: { "white-space": "pre-wrap" } }, [
                  _vm._v(_vm._s(_vm._f("formatChangeString")(row.before))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "log-content",
                    attrs: { slot: "reference" },
                    slot: "reference",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatChangeString")(row.before)) +
                        " "
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "colAfter",
        fn: function ({ row }) {
          return [
            _c(
              "el-popover",
              { attrs: { placement: "top", width: "400", trigger: "hover" } },
              [
                _c("div", { staticStyle: { "white-space": "pre-wrap" } }, [
                  _vm._v(_vm._s(_vm._f("formatChangeString")(row.after))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "log-content",
                    attrs: { slot: "reference" },
                    slot: "reference",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatChangeString")(row.after)) +
                        " "
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "colCreatedAt",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("formatTimestamp")(row.created_at)))]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }